import { formatInTimeZone, OptionsWithTZ } from 'date-fns-tz';

export const getGuessTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getGuessLocale = () => {
  return Intl.DateTimeFormat().resolvedOptions().locale;
};

export const formatDate = (
  date: string | number | Date,
  format: string,
  options?: OptionsWithTZ,
) => {
  return formatInTimeZone(date, getGuessTimezone(), format, options);
};
